var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackingLinkScreenshotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16732 3.16927C3.61503 3.16927 3.16732 3.61699 3.16732 4.16927V15.8359C3.16732 16.3034 3.48812 16.696 3.92159 16.8055L12.8626 7.86453C13.1229 7.60418 13.545 7.60418 13.8054 7.86453L16.834 10.8931V4.16927C16.834 3.61699 16.3863 3.16927 15.834 3.16927H4.16732ZM16.834 12.7787L13.334 9.27875L5.77679 16.8359H15.834C16.3863 16.8359 16.834 16.3882 16.834 15.8359V12.7787ZM1.83398 4.16927C1.83398 2.88061 2.87865 1.83594 4.16732 1.83594H15.834C17.1226 1.83594 18.1673 2.88061 18.1673 4.16927V15.8359C18.1673 17.1246 17.1226 18.1693 15.834 18.1693H4.16732C2.87865 18.1693 1.83398 17.1246 1.83398 15.8359V4.16927ZM7.08403 6.66927C6.85391 6.66927 6.66736 6.85582 6.66736 7.08594C6.66736 7.31606 6.85391 7.50261 7.08403 7.50261C7.31414 7.50261 7.50069 7.31606 7.50069 7.08594C7.50069 6.85582 7.31414 6.66927 7.08403 6.66927ZM5.00069 7.08594C5.00069 5.93535 5.93343 5.00261 7.08403 5.00261C8.23462 5.00261 9.16736 5.93535 9.16736 7.08594C9.16736 8.23653 8.23462 9.16927 7.08403 9.16927C5.93343 9.16927 5.00069 8.23653 5.00069 7.08594Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingLinkScreenshotIcon);
export default __webpack_public_path__ + "static/media/tracking-link-screenshot-icon.52b250c4ab9440c9da8ec25c97baff2d.svg";
export { ForwardRef as ReactComponent };